// modalStack.js
let modalStack = [];
let updateCallbacks = [];

export const modalStackManager = {
  push: (id) => {
    modalStack.push(id);
    updateCallbacks.forEach(cb => cb());
  },
  pop: () => {
    updateCallbacks.forEach(cb => cb());
  },
  isTop: (id) => modalStack.length > 0 && modalStack[modalStack.length - 1] === id,
  subscribe: (callback) => {
    updateCallbacks.push(callback);
    return () => {
      updateCallbacks = updateCallbacks.filter(cb => cb !== callback);
    };
  }
};